webpackJsonp([127261004005480],{

/***/ 1355:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---ignite-session-15-nov-2025-a0e39f21c11f6a62c5ab.js